import { createSelector } from 'reselect';

const selectReminder = state => state.Player.Reminder;

export const selectCreateReminder = createSelector(
  selectReminder,
  reminder => reminder.Create,
);

export const selectDeleteReminder = createSelector(
  selectReminder,
  reminder => reminder.Delete,
);

export const selectListReminder = createSelector(
  selectReminder,
  reminder => reminder.List.data,
);
